<template>
    <div>
        <coop-dashboard v-if="currentUser.app_type === 'ACRECX_MARKETPLACE' && currentOrg.type === 'COOP'"></coop-dashboard>
        <user-dashboard v-if="currentUser.app_type === 'ACRECX_MARKETPLACE' && currentOrg.type !== 'COOP'"></user-dashboard>
        <admin-dashboard v-if="currentUser.app_type === 'ACRECX_EXPRESS'"></admin-dashboard>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import CoopDashboard from "./marketplace/CoopDashboard";
    import UserDashboard from "./marketplace/UserDashboard";
    import AdminDashboard from "./express/AdminDashboard";

    export default {
        name: "Dashboard",
        components: {AdminDashboard, CoopDashboard, UserDashboard},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        mounted() {
            if(this.currentOrg.role === 'INVENTORY_MANAGER') {
                let route = {name: 'expinventory', params: {expressid: this.currentOrg.express_id}};
                this.$router.push(route);
            }
        }
    }
</script>

<style scoped>

</style>
